import React from 'react';

import { ClickableIcon } from '~components';
import { faBan, faLock } from '~components/icon';

interface ComponentProps {
  id: string;
  isIgnored: boolean;
  onIgnore?: (id: string) => void;
  canEdit?: boolean;
  isLocked?: boolean;
}

const ClaimItemActions: React.FC<ComponentProps> = ({ id, isIgnored, onIgnore, canEdit = false, isLocked = false }) => {
  return (
    <div className="d-flex justify-content-center align-items-center gap-2">
      <ClickableIcon
        id={`${id}-ignore`}
        icon={isLocked ? faLock : faBan}
        disabled={isIgnored || !canEdit || isLocked}
        showTooltipWhenDisabled={isLocked}
        onClick={() => onIgnore?.(id)}
        toolTip={isLocked ? 'Cannot modify - linked to statement' : 'Ignore row, will never be claimed'}
      />
    </div>
  );
};

export default ClaimItemActions;
